<div class="token-expired-page">
    <div class="content">
        <h1>Your Dealership Has Already Been Activated</h1>

        <p>
            According to our records, your dealership's EZ DOCS account is already activated. Please complete the form
            below and we will send an email to the
            system administrator(s) letting them know you would like access.
        </p>
        <ng-template #sent>
            <div>Email Sent!</div>
        </ng-template>

        <div>Dealer Code: {{ dealerCode }}</div>

        <hr />

        <form [formGroup]="requestAccessForm">
            <div class="form-group-layout-1">
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="firstName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input formControlName="lastName" matInput />
                </mat-form-field>
            </div>
            <div class="form-group-layout-2">
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input formControlName="email" matInput />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Mobile</mat-label>
                    <input formControlName="mobilePhone" matInput appPhoneMask placeholder="(XXX) XXX-XXXX"
                        maxlength="14" />
                </mat-form-field>
            </div>

            <p>If you have any questions or need help, please reach out to us.</p>

            <div class="support-wrap">
                <p><b>EZ DOCS Support</b></p>
                <p>Phone: {{ tenantSupportPhone }}</p>
                <p>Email: {{ tenantSupportEmail }}</p>
                <p><em>Our support team is available Monday through Friday from 8am to 8pm and Saturdays from 10am to
                        6pm (all times Eastern).</em></p>
            </div>

            <div class="btn-wrap">
                <button mat-button class="secondary" (click)="cancel()">Cancel</button>
                <button mat-button class="primary" (click)="submit()">Submit</button>
            </div>
        </form>
    </div>
</div>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>